module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_null@3x.3198a235.png";